<template>
  <div>
    <!-- TODO should be content col class? -->
    <v-sheet
      v-if="$vuetify.breakpoint.smAndUp"
      class="drop-target grey--text text--lighten-1 mb-2 pos-rel"
      :class="{ dragging: dragging }"
      @dragover="dragging = true"
      @dragleave="dragging = false"
      @drop="dragging = false"
    >
      <v-sheet
        class="grey lighten-3 display-flex align-center justify-center flex-column grey--text text--darken-1 text-center"
        style="min-height: 150px"
      >
        <template v-if="!files || !files.length">
          <span class="mt-3 mb-2 body-1 font-weight-light text-center">Drag and drop a document or click to select one.</span>
          <span class="mt-1 mb-2 body-1 font-weight-light text-center">Supported document formats are Word (.doc or .docx) or PDF.</span>

          <v-icon color="grey">
            mdi-upload
          </v-icon>
        </template>
        <template v-else>
          <!-- TODO multiple files -->
          <v-icon
            :color="mimeType && mimeType.color"
            large
            class="mb-2"
          >
            {{ (mimeType && mimeType.icon) || 'mdi-file-alert' }}
          </v-icon>
          {{ files[0].name }}
        </template>
      </v-sheet>

      <input
        ref="fileInput"
        v-bind="$attrs"
        :multiple="false"
        type="file"
        class="file-upload-file-input"
        @change="filesChange"
      >
    </v-sheet>

    <v-file-input
      ref="vFileInput"
      v-model="files"
      v-bind="$attrs"
      :multiple="false"
      show-size
      :truncate-length="32"
      :append-icon="
        files && files.length
          ? (mimeType && mimeType.icon) || 'mdi-file-alert'
          : 'mdi-paperclip'
      "
      prepend-icon=""
      @click:clear="$refs.fileInput.value = null"
    />
  </div>
</template>

<script>
import { mimeTypes } from '@/utils/mimeTypes.js'

export default {
  name: 'OlDragAndDropFileInput',
  inheritAttrs: false,
  props: {
    /*  accept: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    } */
  },
  data: function () {
    return {
      files: null,
      dragging: false
    }
  },
  computed: {
    mimeType() {
      if (!(this.files && this.files.length)) {
        return {}
      }

      const fileTypes = Array.from(
        new Set(Array.from(this.files).map((file) => file.type))
      )

      if (fileTypes.length === 1) {
        return this.mimeTypes[fileTypes[0]]
      } else {
        return this.mimeTypes['multiple']
      }
    }
  },
  watch: {
    files: {
      handler: function (newVal, oldVal) {
        this.$refs.vFileInput.validate(true)
        this.$emit('change', [this.files].flat())
      },
      deep: true
    }
  },
  beforeCreate() {
    this.mimeTypes = mimeTypes
  },
  methods: {
    filesChange() {
      this.files = Array.from(this.$refs.fileInput.files)
    }
  }
}
</script>

<style scoped>
::v-deep .file-upload-file-input,
::v-deep .file-upload-file-input * {
  opacity: 0;
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
  left: 0 !important;
  top: 0 !important;
  cursor: pointer !important;
}

.dragging {
  opacity: 0.5;
}
</style>
